import { PlessViewUtilsSub } from './../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW9002Model } from '../kymw9002.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 権限コンボボックスデータソース取得
 *
 * @export API通信成功時の処理
 * @class GetAuthorityComboBoxValueService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAuthorityComboBoxValueService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9002Model;
  private successFunc: Function;


  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAuthorityComboBoxValueService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({})
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9002Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAuthorityComboBoxValueService
   */
  execute(model: KYMW9002Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getAuthorityComboBoxValue', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAuthorityComboBoxValueService
   */
  success(data: any) {
    this.model.updateAuthorityComboBox(data);
    // ユーザー詳細表示の時はユーザー情報取得
    if (!PlessViewUtilsSub.isEmpty(this.model.userID)) {
      const vo = this.model.kymw9002Component.createUserVO();
      this.model.kymw9002Component.getUserInfomationDetail.execute(this.model, vo);
    } else {
      // ユーザー新規作成の時は親画面で選択されている権限セットIDを設定する
      this.model.kymw9002Component.setAuthorityCmb(this.model.kymw9002Component.getAuthoritySetId());
    }
  }

}
